export * from './item-small-generic.component';